/**
 * Mapa widget_id → metadados do Cricket (palco, exportação ZIP, pré-visualização).
 */

export const CRICKET_LIST_LAMP_COLOR_HEX = {
  todo: '#f59e0b',
  doing: '#3b82f6',
  done: '#22c55e',
};

/**
 * @param {Array<{ id: string, list_key?: string, title?: string }>} lists
 * @param {Array<{ id: string, list_id: string, widget_id?: string|null, title?: string, body?: string|null }>} cards
 * @returns {Record<string, { cardId: string, title: string, body: string, listTitle: string, listKey: string, lampColor: string }>}
 */
export function buildCricketWidgetBadgeMap(lists, cards) {
  const listById = Object.fromEntries((lists || []).map((l) => [l.id, l]));
  const m = {};
  for (const c of cards || []) {
    if (!c.widget_id) continue;
    const list = listById[c.list_id];
    const listKey = list?.list_key || '';
    m[String(c.widget_id)] = {
      cardId: c.id,
      title: c.title,
      body: c.body || '',
      listTitle: list?.title || '—',
      listKey,
      lampColor: CRICKET_LIST_LAMP_COLOR_HEX[listKey] || '#a855f7',
    };
  }
  return m;
}
